import { action, observable, runInAction } from "mobx";
import {
  ContractsPriceTemplates,
  DeleteContractsPriceTemplate,
  DuplicateContractsPriceTemplate
} from "@graphql";
import { Template } from "../utils";
import { ContractPriceTemplateFormInput } from "@config_editor/ContractsPriceTemplates/ContractsPriceTemplateFormInput";
import { store } from "@store";

export class ContractsPriceTemplateSearchStore {
  @observable items: Template[] = [];
  @observable loading = false;
  @observable total = 0;
  @observable textFilter = "";
  @observable page = 0;
  @observable rowsPerPage = 20;

  private onlyPrivate = !store().user.can("contracts-price-template:create:all");

  constructor() {
    this.fetch();
  }

  @action
  fetch = async () => {
    this.loading = true;
    try {
      const result = await ContractsPriceTemplates.func(
        {
          filter: { text: this.textFilter || "" },
          skip: this.page * this.rowsPerPage,
          limit: this.rowsPerPage,
          onlyPrivate: this.onlyPrivate
        },
        { fetchPolicy: "network-only" }
      );
      runInAction(() => {
        this.items = result.data.list.items as Template[];
        this.total = result.data.list.total;
      });
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  };

  @action
  setTextFilter = (value: string) => {
    this.textFilter = value;
    this.page = 0;
    this.fetch();
  };

  @action
  setPage = (page: number) => {
    this.page = page;
    this.fetch();
  };

  @action
  setRowsPerPage = (rowsPerPage: number) => {
    this.rowsPerPage = rowsPerPage;
    this.page = 0;
    this.fetch();
  };

  duplicate = async (row: Template) => {
    const data = ContractPriceTemplateFormInput.CreateFromFragment(row);
    await DuplicateContractsPriceTemplate.func({ data });
    this.fetch();
  };

  delete = async (id: string) => {
    await DeleteContractsPriceTemplate.func({ id });
    this.fetch();
  };
}
